import React, { useState } from 'react';
import { Nav, Form, InputGroup, OverlayTrigger, Popover, Col, Row } from 'react-bootstrap';
import { ChevronDown, Search, X } from 'react-bootstrap-icons';
import InputDynamic from '../InputDynamic';
import BtnDynamic from '../BtnDynamic';
import utils from '../../../utils';
// import TagDisplay from '../../TagDisplay'; Will add back in once backend is built
import PillsDynamic from '../PillsDynamic';

function SearchComponent({ onQuery, tenantSetting, tenantName=null }) {

    const [showPopover, setShowPopover] = useState(false);
    const [ advTypedQueryObj, setAdvTypedQueryObj ] = useState({
        musts: '',
        shoulds: '',
        must_not:'',
        tags: '',
    })
    const [ advSearchQueryObj, setAdvSearchQueryObj ] = useState({
        musts: [],
        shoulds: [],
        must_not: [],
        tags: [],
    });

    const addKeysToQuery = (e) => {
        e.preventDefault();
        if (e.which === 32){
            e.target.value = `${e.target.value} `
        }
        if(e.keyCode === 13) {
            let queryTrimmed = e.target.value.trim();
            let sterilizedQuery = JSON.stringify({ query: queryTrimmed });
            let encodedQuery = encodeURIComponent(sterilizedQuery);
            onQuery(encodedQuery);
            e.currentTarget.value = "";
        } 
    }
        
    // Helper function to update advanced search query in state
    const updateAdvancedQuery = (targetId) => {
        const trimmedQuery = advTypedQueryObj[targetId].trim();
        if (trimmedQuery) {
            setAdvSearchQueryObj((prev) => ({
                ...prev,
                [targetId]: [...prev[targetId], trimmedQuery],
            }));
            setAdvTypedQueryObj((prevQuery) => ({
                ...prevQuery,
                [targetId]: '', // Clear the input for the specific targetId
            })); // Clear the input
        }
    };

    const handleInputChange = (e) => {
        e.preventDefault();
        
        const { code, key, target } = e;
        const targetId = target?.id;
    
        // Ensure targetId is valid
        if (!targetId || !advSearchQueryObj.hasOwnProperty(targetId)) {
            return;
        }

        // Handle key events
        switch (code) {
            case 'Enter':
                updateAdvancedQuery(targetId);
                break;
            case 'Tab':
                if (targetId !== 'shoulds') {
                    updateAdvancedQuery(targetId);
                }
                break;
            case 'Backspace':
                // Remove the last character from the input for the specific targetId
                setAdvTypedQueryObj((prevQuery) => ({
                    ...prevQuery, 
                    [targetId]: prevQuery[targetId].slice(0, -1), // Remove the last character
                }))
                break;
            default:
                if (key.length === 1) {
                    // Append the new key to the input for the specific targetId
                    setAdvTypedQueryObj((prevQuery) => ({
                        ...prevQuery,
                        [targetId]: prevQuery[targetId] + key, // Append the key to the current value
                    }));
                }
                break;
        }
    };

    const addUnsubmittedQueriesToObj = (typedQuery, submittedQuery) => {
        const updatedQueryObj = { ...submittedQuery }; // Create a copy of the submitted query object

        // Iterate through each key in the typed query object
        for (const key in typedQuery) {
            if (typedQuery.hasOwnProperty(key)) {
                const typedValue = typedQuery[key].trim(); // Get the trimmed value of the typed query
                if (typedValue) {
                    updatedQueryObj[key] = [...updatedQueryObj[key], typedValue]; // Add the typed value to the corresponding key in the submitted query object
                }
            }
        }
        return updatedQueryObj; // Return the updated query object
    }

    // Function to handle the submission of the advanced search query
    // This function combines the typed query and the submitted query, and then navigates to the search results page
    const submitAdvancedQuery = (e) => {
        e.preventDefault();
        let objToSend = addUnsubmittedQueriesToObj(advTypedQueryObj, advSearchQueryObj); // Combine typed and submitted queries
    
        // Handle the advanced search query submission here
        // Pass the advanced search query to the to the SearchResultsPage.js component
        const serializedQuery = JSON.stringify(objToSend); // Serialize the query object
        const encodedQuery = encodeURIComponent(serializedQuery); // Encode the serialized query
        onQuery(encodedQuery); // Call the onQuery function with the encoded query
        
        // Clear the input after submission
        setAdvTypedQueryObj({
            musts: '',
            shoulds: '',    
            must_not:'',
            tags: '',
        });
        
        setAdvSearchQueryObj({ // Reset the advanced search query
            musts: [],
            shoulds: [],
            must_not: [],
            tags: [],
        });

        setShowPopover(false); // Close the popover after submission
    }
    const handleClose = () => {
        setAdvTypedQueryObj({
            musts: '',
            shoulds: '',
            must_not:'',
            tags: '',
        }); // Clear the input when the close button is clicked
        setAdvSearchQueryObj({ // Reset the advanced search query
            musts: [],
            shoulds: [],
            must_not: [],
            tags: [],
        });
        setShowPopover(false); // Close the popover when the close button is clicked
    }

    return (
        <>
            <Nav.Link className="tenant-app-link app-search"> 
                <InputGroup className={tenantName === 'BMGF' ? 'search-margin' : ''}>
                    <InputGroup.Text><Search className='svg-20' /></InputGroup.Text>
                    <Form.Control onKeyUp={(e) => addKeysToQuery(e)} type="text" placeholder="Search news" />
                    <OverlayTrigger
                        placement='bottom'
                        trigger='click'
                        key='bottom'
                        rootClose
                        show={showPopover} // Control visibility with state
                        onToggle={(isVisible) => setShowPopover(isVisible)} // Update state when toggled
                        overlay={
                            <Popover id={`popover-positioned-bottom`} 
                                className='p-06 p-b-end-07 px-width-450 advanced-search-popover border-corner-radius-rounding-04 border-primary-light surface-primary-light' 
                            >
                                <div id="example-collapse-text" className={tenantName}>
                                    <Form>
                                        <Row>
                                            <Col>
                                                <label className='label-small m-b-end-06'>Advanced Search</label>
                                            </Col>
                                            <Col className='align-right'>
                                                <X className='svg-16' onClick={() => handleClose()} /> {/* Close popover */}
                                            </Col>
                                        </Row>
                                        <label className='label-medium m-b-start-02 m-b-end-03'>All of these words</label>                                       
                                        <InputDynamic
                                            placeholder={'Add multiple words with Enter or Tab'}
                                            controlId={'musts'} 
                                            className={'input-underline m-b-end-03 full-width body-small-condensed'}
                                            trackChange={handleInputChange}
                                            value={advTypedQueryObj.musts ? advTypedQueryObj.musts : ''} // Show query only if active
                                        />
                                        <PillsDynamic
                                            pillList={advSearchQueryObj.musts ? advSearchQueryObj.musts : []} 
                                            className={'input-pill-selections border-corner-radius-rounding-08 label-small'}
                                            handleEdit={(item) => {
                                                // Remove the pill from the list
                                                setAdvSearchQueryObj((prev) => ({
                                                    ...prev,
                                                    musts: prev.musts.filter((pill) => pill !== item),
                                                }));
                                            }}
                                        />
                                        <label className={advSearchQueryObj.musts && advSearchQueryObj.musts.length > 0 ?'label-medium m-b-start-06 m-b-end-03' : 'label-medium m-b-start-05 m-b-end-03'}>Any of these words</label>                                       
                                        <InputDynamic
                                            placeholder={'Type a word or phrase, then press Enter'}
                                            controlId={'shoulds'} 
                                            className={'input-underline m-b-end-03 full-width body-small-condensed'}
                                            trackChange={handleInputChange}
                                            value={advTypedQueryObj.shoulds ? advTypedQueryObj.shoulds : ''} // Show query only if active
                                        />
                                        <PillsDynamic
                                            pillList={advSearchQueryObj.shoulds ? advSearchQueryObj.shoulds : []} 
                                            className={'input-pill-selections border-corner-radius-rounding-08 label-small'}
                                            handleEdit={(item) => {
                                                // Remove the pill from the list
                                                setAdvSearchQueryObj((prev) => ({
                                                    ...prev,
                                                    shoulds: prev.shoulds.filter((pill) => pill !== item),
                                                }));
                                            }}
                                        />
                                        <label className={advSearchQueryObj.shoulds && advSearchQueryObj.shoulds.length > 0 ? 'label-medium m-b-start-06 m-b-end-03' : 'label-medium m-b-start-05 m-b-end-03'}>None of these</label>
                                        <InputDynamic
                                            placeholder={'Add multiple words with Enter or Tab'}
                                            controlId={'must_not'} 
                                            className={'input-underline m-b-end-03 full-width body-small-condensed'}
                                            trackChange={handleInputChange}
                                            value={advTypedQueryObj.must_not ? advTypedQueryObj.must_not : ''} // Show query only if active
                                        />
                                        <PillsDynamic
                                            pillList={advSearchQueryObj.must_not ? advSearchQueryObj.must_not : []} 
                                            className={'input-pill-selections border-corner-radius-rounding-08 label-small'}
                                            handleEdit={(item) => {
                                                // Remove the pill from the list
                                                setAdvSearchQueryObj((prev) => ({
                                                    ...prev,
                                                    must_not: prev.must_not.filter((pill) => pill !== item),
                                                }));
                                            }}
                                        />
                                        {/*LEAVE---- Backend elasticsearch currently doesn't have this capability --- Will add back in once backend is built */}
                                        {/* <hr className='adv-search-hr'/>
                                        <label className='label-medium m-b-end-03'>Include these tags</label>
                                        <InputDynamic
                                            placeholder={'Search for tags'}
                                            controlId={'tags'} 
                                            className={'input-underline full-width body-small-condensed'}
                                            trackChange={handleInputChange}
                                            value={advTypedQueryObj.tags ? advTypedQueryObj.tags : ''} // Show query only if active
                                        />
                                        <TagDisplay 
                                            tagList={advSearchQueryObj.tags ? advSearchQueryObj.tags : []} 
                                            flatList={true}
                                            linksActive={false}
                                            className={'input-tag-selections'}
                                            handleEdit={(item) => {
                                                // Remove the pill from the list
                                                setAdvSearchQueryObj((prev) => ({
                                                    ...prev,
                                                    tags: prev.tags.filter((pill) => pill !== item),
                                                }));
                                            }}
                                        /> */}
                                        <div className={advSearchQueryObj.must_not && advSearchQueryObj.must_not.length > 0 ? 'm-b-start-06 align-right' : 'm-b-start-05 align-right'}>
                                            <BtnDynamic 
                                                classes='surface-brand-primary btn-primary-lg border-corner-radius-rounding-08 p-i-04 p-b-02'
                                                actionHandler={submitAdvancedQuery} 
                                                content={{
                                                    name: 'Search',
                                                    icon: utils.getIcon('search')}
                                              }
                                                loading={false}
                                                idName={'adv-search-submit'}
                                            />
                                        </div>
                                    </Form>
                                </div>
                            </Popover>
                        }
                    >
                        <InputGroup.Text className='search-chevron'><ChevronDown/></InputGroup.Text>
                    </OverlayTrigger>
                </InputGroup>
            </Nav.Link>
        </>
    )
}

export default SearchComponent
